
import Auth from './auth'
import { AgentAPi } from '../helpers/apiEndPoint'
import ResponseManager from './ResponseManager'
import axios from 'axios'

export default {


    // This Api is call on agent home page,
    // it display all the information belong to agent assistnat, location , and current agent data summary
  
    getCompleteUrl(endPoint){
        return AgentAPi.showHome+endPoint;
    },

    async getHome(endPoint,type,paramsdata) {
        try {
        
            Auth.checkAuth();
            var  response=null;
           if(type=='get'){
               
               
            let parms=new URLSearchParams(paramsdata).toString();
             response = await axios.get(AgentAPi.showHome+endPoint+'?'+parms, { headers: Auth.configHeader() })
           }
            if(type=='post')
             response = await axios.post(AgentAPi.showHome+endPoint,paramsdata, { headers: Auth.configHeader() })
             
             if(type=='put'){
               
             response = await axios.put(AgentAPi.showHome+endPoint+"/"+ `${paramsdata.id}`,paramsdata, { headers: Auth.configHeader() })
             }

             if(type=='delete'){
                 response = await axios.delete(AgentAPi.showHome+endPoint+"/"+ `${paramsdata.id}`, { headers: Auth.configHeader() })
  
        
               
                //response = await axios.delete(AgentAPi.showHome+endPoint, { headers: Auth.configHeader() },{ data:paramsdata})
             }


            return ResponseManager.handleRsponse(response.data);

        } catch (error) {
            console.log('Error', error.message)
            if (error.response.status === 401) {
                this.$toastr['error']('Invalid Credentials', 'Error')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
            }
        }
    },



    printResponse(response) {
        console.log(JSON.stringify(response));
    },





}
